import Text from '@passkeys/ui/text';

import useTotalBalance from '@/ui/hooks/use-total-balance.js';
import FancyAmount from '../../fancy-amount/fancy-amount.js';
import { FancyAmountSkeleton } from '../../fancy-amount/index.js';

type ResponsiveHeaderProps = {
  title: string;
};

function ResponsiveHeader({ title }: ResponsiveHeaderProps) {
  const { value: totalBalance, loading: isTotalBalanceLoading } =
    useTotalBalance();

  return (
    <header className="flex flex-col p-6 md:gap-y-10 md:px-12 md:py-8">
      <div className="hidden md:block">
        {isTotalBalanceLoading ? (
          <FancyAmountSkeleton />
        ) : (
          <FancyAmount value={totalBalance.toDefaultNumber()} />
        )}
      </div>

      <Text as="h1" size={24}>
        {title}
      </Text>
    </header>
  );
}

export default ResponsiveHeader;
